<template>
  <div class="am-payment-selection">
    <div class="am-dialog-header">
      <span>Payment Selection</span>
    </div>
    <div>
      <div class="am-payment-selection-table">
        <table>
          <tbody>
          <tr>
            <td>Finance Company:</td>
            <td>{{paymentOptions.financeCompanyName}}</td>
          </tr>
          <tr>
            <td>Quote Number:</td>
            <td>{{paymentOptions.QuoteCode}}</td>
          </tr>
          <tr>
            <td>Quote Date:</td>
            <td>{{quoteDate}}</td>
          </tr>
          <tr>
            <td>Amount Financed:</td>
            <td>${{paymentOptions.AmountFinanced}}</td>
          </tr>
          <tr>
            <td>Contract Status:</td>
            <td>Quoted</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="am-payment-selection-memo">
        <span>{{paymentOptions.integrationMemo}}</span>
      </div>
    </div>
    <div class="am-finance-main-table">
      <table class="am-finance-table">
        <thead>
        <tr>
          <th></th>
          <th class="am-text-align-left am-custom-padding">Options</th>
          <th class="am-text-align-right am-custom-padding">Down Payment</th>
          <th class="am-text-align-right am-custom-padding">Monthly Payment</th>
          <th class="am-text-align-left am-custom-padding-left">No.of Payments</th>
          <th class="am-text-align-right am-custom-padding">Interest</th>
          <th class="am-text-align-right am-custom-padding-right">Set Up Fee</th>
          <th class="am-text-align-left am-custom-padding">First Due</th>
        </tr>
        </thead>
        <tbody>
          <tr v-for="contracts in paymentOptions.paymentOptions">
            <td><input v-show="paymentOptions.transactionType !== 'quote' || paymentOptions.transactionType !== 'quoteFromPolicy'" type="radio" name="contract" v-model="optionSelected" :value="contracts.NumberOfPay"></td>
            <td class="am-text-align-left am-custom-padding">{{contracts.NumberOfPay}} - Pay</td>
            <td class="am-text-align-right am-custom-padding">${{contracts.DownPay}}</td>
            <td class="am-text-align-right am-custom-padding">${{contracts.MonthlyPayment}}</td>
            <td class="am-text-align-left am-custom-padding-left">{{contracts.NumberOfPay}}</td>
            <td class="am-text-align-right am-custom-padding">${{contracts.Interest}}</td>
            <td class="am-text-align-right am-custom-padding-right">${{contracts.SetupFee}}</td>
            <td class="am-text-align-left am-custom-padding">{{policyMinDate}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-show="paymentOptions.transactionType === 'policy' || paymentOptions.transactionType === 'add' || paymentOptions.transactionType === 'renewal' || paymentOptions.transactionType === 'convertQuote'" class="am-finance-eSignature-section">
      <div v-if="paymentOptions.hasEsignature !== 0" class="am-finance-eSignature">
        <input type="checkbox" :checked="isChecked" :disabled="isDisabled" v-model="isChecked" @change="checkDisabled()"><span>eSignature</span>
      </div>
      <div v-if="isChecked">
        <div>Customer Email:
        <input type="text" v-model="customerEmail" @change="checkDisabled()" class="am-finance-eSignature-customer-email" :title="customerEmailTitle">
        </div>
        <div v-if="paymentOptions.isDesignated === 1">Agent Email:
        <input type="text" v-model="quoteAgentEmail" @change="checkDisabled()" class="am-finance-eSignature-agent-email" :title="quoteAgentEmailTitle">
        </div>
      </div>
    </div>
    <div class="am-blue-border"></div>
    <div class="am-buttons">
      <button v-show="paymentOptions.transactionType !== 'quote'" type="button" class="btn btn-primary btn-xs" title="Generate Contract" :disabled="activateGenerateContract === false" @click="submit()">Generate Contract</button>
      <button v-show="paymentOptions.transactionType !== 'quote'" type="button" class="btn btn-secondary btn-xs" title="Cancel" @click="closeModal()">Cancel</button>
      <button v-show="paymentOptions.transactionType === 'quote'" type="button" class="btn btn-primary btn-xs" title="Done" @click="closeModal()">Done</button>
    </div>
  </div>
</template>
<script>
import api from './../http'
import moment from 'moment'
export default {
  name: 'PaymentSelection',
  data () {
    return {
      paymentOptions: {},
      isChecked: false,
      isDisabled: false,
      isCancelled: true,
      optionSelected: 0,
      paymentSelected: {},
      downPayment: '',
      activateGenerateContract: false,
      customerEmail: this.paymentOptions.customerEmail,
      customerEmailTitle: "",
      quoteAgentEmail: "",
      quoteAgentEmailTitle: "",
      quoteDate: moment().format("L"),
      policyMinDate: this.getFirstDueDate(this.paymentOptions.policyMinDate),
      amountsIfAddOn: this.paymentOptions.amountsIfAddOn,
      recordName: this.paymentOptions.recordName,
      selectedPayment:{
          numberOfPay:{},
      }
    }
  },
  methods: {
      closeModal() {
          this.$store.dispatch('events/fireEvent', { name: 'payment-selection-close', data: {'customerId': this.paymentOptions.customerId, 'isCancelled': this.isCancelled, 'requote': this.paymentOptions.requote} })
      },

      submit() {
        if (this.isCancelled && this.paymentOptions.requote.length > 0) {
          this.isCancelled = false;
        }
          let self = this
          self.paymentSelected = self.paymentOptions.paymentOptions.find(paymentOption => paymentOption.NumberOfPay == self.optionSelected)
          self.downPayment = self.paymentSelected.DownPay
          api.postRequest('customer/finance/integrated/generate-contract', {'numberOfPay':self.optionSelected, 'requiresESignature': self.isChecked, 'quoteCode': self.paymentOptions.QuoteCode, 'financeId': self.paymentOptions.financeId, 'customerId': self.paymentOptions.customerId, 'paymentSelected': self.paymentSelected, 'downPayment': self.downPayment, 'customerEmail': self.customerEmail, 'agentEmail': self.quoteAgentEmail}).then(function (data) {
            self.closeModal()
            self.paymentOptions.path = data.data.results.fullFilePath
            self.$store.dispatch('events/fireEvent', {
              name: 'open-contract-agreement',
              data: {
                'isChecked': self.isChecked,
                'customerId': self.paymentOptions.customerId,
                'policyIds': self.getPolicyIds(),
                'customerEmail': self.customerEmail,
                'path': self.paymentOptions.path,
                'downPayment': self.downPayment,
                'fundingStatus' : self.paymentOptions.fundingStatus,
                'entryType' : data.data.results.entryType,
                'amountsIfAddOn' : self.amountsIfAddOn,
                'recordName' : self.recordName
              }
            })
          }).catch(function() {
            self.closeModal()
            self.$store.dispatch('events/fireEvent', { name: 'open-contract-error', data: null})
          })
      },

      checkDisabled() {
        this.customerEmailTitle = this.validateEmail(this.customerEmail)
        this.quoteAgentEmailTitle = this.validateEmail(this.quoteAgentEmail)
        let optionSelected = (this.optionSelected > 0 && this.isDisabled)
        let optionSelectedNotChecked = (this.optionSelected > 0 && (!this.isDisabled && !this.isChecked))
        let optionSelectedChecked = (this.optionSelected > 0 && !this.isDisabled && this.isChecked && this.customerEmail !== "")
        let onlyOptionSelected = (this.optionSelected > 0 && (this.isDisabled || !this.isChecked))
        if((optionSelected || optionSelectedChecked || optionSelectedNotChecked) && (this.customerEmailTitle === "" && this.quoteAgentEmailTitle === "")) {
          this.activateGenerateContract = true
        } else if (onlyOptionSelected) {
          this.activateGenerateContract = true
        } else {
          this.activateGenerateContract = false
        }
      },
      validateEmail(email) {
        email = typeof email === 'undefined' ? '' : email
        let emailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
         let emailTitle = ""
         if(email === "") {
             emailTitle = "Please add an email!"
         } else if(email.search("@") === -1) {
             emailTitle = "Please add a valid email. Email missing @!"
         } else if (!email.match(emailFormat)) {
             emailTitle = "Please add a valid email!"
         }
         return emailTitle;
      },
      getPolicyIds() {
        var ids = '';
        this.paymentOptions.policyIds.forEach(policy => {
          ids = policy + ',' + ids
        })
        return ids.slice(0,ids.length-1);
      },
      getFirstDueDate(date) {
         let minDate = moment(date)
         return minDate.add(25, 'days').format('L')
      }
  },

  mounted() {
    if (this.paymentOptions.hasEsignature === 1 && this.paymentOptions.isMandatory === 0) {
        this.isChecked = true;
    }
    if (this.paymentOptions.hasEsignature === 1 && this.paymentOptions.isMandatory === 1) {
        this.isChecked = true;
        this.isDisabled = true;
    }
    this.quoteAgentEmail = (this.paymentOptions.isDesignated === 0) ? this.$store.state.auth.user.email : this.paymentOptions.designatedQuoteAgentEmail;
  },

  asyncComputed: {
      optionSelected: {
          get() {
             this.checkDisabled()
          }
      }
  },
  props: {
    paymentOptions: Object,
    path: String,
  },
}
</script>

<style scoped>
  .am-payment-selection {
    width: 700px;
    background-color: whitesmoke;
    overflow: hidden;
  }

  .am-dialog-header {
    height: 35px;
    background-color: #428bca;
    padding: 10px;
    top: 0;
    color: white;
    font-weight: 700;
  }

  .am-finance-main-table {
    padding: 0 5px 10px 10px;
    height: 110px;
    overflow-y: scroll;
    width: 100%;
  }

  .am-finance-eSignature-section {
    padding: 0px 0px 15px 15px;
  }

  .am-finance-table {
    position: relative;
    border-collapse: collapse;
    width: 100%;
  }

  .am-finance-table th {
    position: sticky;
    background-color: black;
    color: white;
    top: 0;
  }

  .am-finance-table td, .am-finance-table th {
    font-size: 11px;
  }

  .am-finance-table tbody tr:nth-child(odd) {
    background-color: #ECECEC;
  }

  .am-finance-table tbody tr:nth-child(even) {
    background-color: #F4F4F4;
  }

  .am-payment-selection-table {
    padding: 10px 0px 10px 10px;
    float: left;
  }

  .am-payment-selection-table td {
    padding: 0px 5px 0px 5px;
  }

  .am-payment-selection-memo {
    float: right;
    width: 200px;
    padding: 10px;
    word-break: break-word;
  }

  .am-payment-selection-memo span {
    color: red;
  }

  .am-buttons {
    bottom: 0;
    padding: 9px 7px 10px 0px;
    float: right;
  }

  .am-buttons button {
    margin: 0px 2px 0px 0px;
  }

  .am-blue-border {
    display: block;
    width: 100%;
    border-top: 1px solid #4297d7;
    margin-top: 10px;
  }

  .am-finance-eSignature {
    margin-top: 10px;
  }

  .am-finance-eSignature-customer-email {
    margin-top: 10px;
    margin-left: 10px;
    width: 200px;
  }

  .am-finance-eSignature-agent-email {
    margin-top: 10px;
    margin-left: 30px;
    width: 200px;
  }

  .am-text-align-right {
    text-align: right;
  }

  .am-text-align-left {
    text-align: left;
  }

  .am-custom-padding-left {
    padding-left: 20px;
  }

  .am-custom-padding-right {
    padding-right: 20px;
  }

  .am-custom-padding {
    padding: 0;
  }
</style>
